import CountUp, { useCountUp } from "react-countup";

export default function HomeCounter({extraClass}) {
    useCountUp({
        ref: "counter",
        start: 0,
        end: 1234567,
        delay: 1000,
        duration: 3000,
    });

  return (
    <>
    <div className={`home-counter ${extraClass}`}>
        <div className="container">
            <div className="row">  

                <div className="col-lg-12">
                    <div className="counter-row">                   
                        <div>
                            <h4><CountUp end="30000" enableScrollSpy/></h4>
                            <p>Sq. ft. <br/>Manufacturing Area</p>
                        </div>

                        <div>
                            <h4><CountUp end="200" enableScrollSpy formattingFn={(value) => value.toString().padStart(2, "0")}/></h4>
                            <p>Kitchen Capacity <br/>Per Month</p>
                        </div>

                        <div>
                            <h4><CountUp end="3" enableScrollSpy/></h4>
                            <p>Showrooms</p>
                        </div>

                        <div>
                            <h4><CountUp end="12" enableScrollSpy/><small>+</small></h4>
                            <p>Years of <br/>Experience</p>
                        </div>

                        <div>
                            <h4><CountUp end="2500" enableScrollSpy  separator=""/></h4>
                            <p>Projects Completed <br/>Across India</p>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    </div>
    </>
  )
}
